export const Tier3ActiveCollectibles = [
    ['Book of Shadows', '58'],
    ['Book of Revelations', '78'],
    ['The Nail', '83'],
    ['Forget Me Now', '127'],
    ['Guppy\'s Paw', '133'],
    ['Guppy\'s Head', '145'],
    ['Prayer Card', '146'],
    ['Crystal Ball', '158'],
    ['D100', '283'],
    ['D4', '284'],
    ['Diplopia', '347'],
    ['Teleport 2.0', '419'],
    ['Glowing Hour Glass', '422'],
    ['Mom\'s Box', '439'],
    ['D1', '476'],
    ['Smelter', '479'],
    ['Mama Mega!', '483'],
    ['Eden\'s Soul', '490'],
    ['Mystery Gift', '515'],
    ['Mr. ME!', '527'],
    ['Book of the Dead', '545'],
    ['Sulfur', '556'],
    ['Red Key', '580'],
    ['Book of Virtues', '584'],
    ['Eternal D6', '609'],
    ['Urn of Souls', '640'],
    ['Vade Retro', '653'],
    ['Friend Finder', '687'],
    ['Berserk!', '704'],
    ['Dark Arts', '705'],
    ['Suplex!', '709'],
    ['Lemegeton', '712'],
    ['Sumptorium', '713'],
    ['Anima Sola', '722'],
    ['Gello', '728'],
];